// Internal dependencies
import cloneDeep from 'lodash.clonedeep';
import get from 'lodash.get';
import isEqual from 'lodash.isequal';
import merge from 'lodash.merge';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import ReactDOM from "react-dom";
import { withRouter } from 'react-router-dom';

// External dependencies
import BenchmarkChart from '../../blocks/Charts/Benchmark';
import Loading from '../../../Global/Loading';
import PageStatus from '../../../Teacher/PageStatus';
import ClassWithNoStudents from '../../../Teacher/ErrorMessages/ClassWithNoStudents';
import Error from '../../../Teacher/Error';
import { states } from '../../values/enums';
import creators from '../../state/benchmark/creators';
import dyslexiaCreators from '../../state/dyslexia/creators';
import { uuidToHEX } from '../../../../services/util';

class BenchmarkContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isScrolled: false,
      width: 0,
      sortReport: null,
      componentError: null,
    };

    this.onSortChange = this.onSortChange.bind(this);
    this.onChartClick = this.onChartClick.bind(this);
    this.onChartScroll = this.onChartScroll.bind(this);
  }

  componentDidMount () {
    this.setState({
      width: ReactDOM.findDOMNode(this).offsetWidth,
    });
    this.props.initializeData();

    // Configure sorts based on whether we're in dyslexia mode
    if(this.props.dyslexiaMode) {
      this.setState({sortReport: this.props.dyslexiaSort});
    } else {
      this.setState({sortReport: this.props.benchmarkSort});
    }
  }



  onSortChange (sort) {
    this.state.sortReport(sort);
  }

  // conditionally enable scroll css styling
  onChartScroll(event) {
    let scrollTop = event.nativeEvent.srcElement.scrollTop;
    let isScrolled = (scrollTop > 8);

    if(isScrolled !== this.state.isScrolled) {
      this.setState({isScrolled: isScrolled})
    }
  }

  // This function will be used to react to chart clicks
  onChartClick (id) {
    let formattedId = uuidToHEX(id);
    this.props.history.push('/teacher/gradebook/scoring/' + formattedId);
  }

  render () {
    const { selectedMetric, selectedLocale } = this.props;
    let complete;
    let reportStatus;
    let sorts;
    if(this.props.dyslexiaMode) {
      complete = cloneDeep(this.props.dyslexiaReport);
      reportStatus = this.props.dyslexiaReportStatus;
      sorts = this.props.dyslexiaSorts;
    } else {
      complete = cloneDeep(this.props.report);
      reportStatus = this.props.reportStatus;
      sorts = this.props.sorts;
    }

    // scroll styles
    const reportContainerStyles = cx({
     'reports-container': true,
     'benchmark': true,
     'scrolled': this.state.isScrolled
    });
    const paddingContainerStyles = cx({
     'reports-benchmark-padding-container': true,
     'unscrolled': !this.state.isScrolled
    });

    if(this.state.componentError) {
      return <Error customMessage={this.state.componentError} />;
    }

    let BenchmarkContents;
    if(reportStatus && reportStatus.type === states.COMPLETE) {
      if(complete && complete.scores.length > 0) {
        BenchmarkContents =
          <BenchmarkChart
            report={complete}
            sorts={sorts}
            onClick={this.onChartClick}
            onScroll={this.onChartScroll}
            onSortChange={this.onSortChange}
            containerWidth={this.state.width}
            mode={this.props.dyslexiaMode ? "DYSLEXIA" : "DEFAULT"}
            selectedMetric={selectedMetric}
            selectedLocale={selectedLocale}
          />;
      } else if(!this.props.students || (Array.isArray(this.props.students) && this.props.students.length == 0)){
        BenchmarkContents = <ClassWithNoStudents />;
      } else {
        let equated = false;
        if(this.props.selectedMetric && this.props.selectedMetric.value == 'ORF' && this.props.selectedEquating) {
          equated = true;
        }
        BenchmarkContents =
          <PageStatus
            isAggregateReport={true}
            viewText="scores as they relate to benchmarks"
            equated={equated}
          />;
      }
    } else if(reportStatus && reportStatus.type === states.ERROR) {
      BenchmarkContents = <Error />;
    } else {
      BenchmarkContents = <Loading />;
    }

    return (
      <div className={reportContainerStyles}>
          <div className={paddingContainerStyles}>
            {BenchmarkContents}
          </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  selectedMetric: get(state, 'reports.teacher.selections.metric', {}),
  selectedEquating: get(state, 'reports.teacher.equatingSelection', true),
  selectedLocale: get(state, 'reports.teacher.selectedLocale', null),
  sorts: get(state, 'reports.benchmark.sorts'),
  report: get(state, 'reports.benchmark.report.data', null),
  reportStatus: get(state, 'reports.benchmark.report.status', null),
  dyslexiaSorts: get(state, 'reports.dyslexia.sorts'),
  dyslexiaReport: get(state, 'reports.dyslexia.report.data', null),
  dyslexiaReportStatus: get(state, 'reports.dyslexia.report.status', null),
});

const mapDispatchToProps = (dispatch) => ({
  benchmarkSort: (sort) => dispatch(creators.benchmarkSort(sort)),
  dyslexiaSort: (sort) => dispatch(dyslexiaCreators.dyslexiaSort(sort)),
});

BenchmarkContainer.propTypes = {
  report: PropTypes.object,
  initializeData: PropTypes.func,
  dyslexiaMode: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BenchmarkContainer))
